"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4 17.17V4h16v6h2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-2H5.17z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
}, "1")], 'QuickreplyOutlined');